import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Client, Motorcycle } from '@/lib/types';

type MotoForClient = Pick<Motorcycle, 'id' | 'modele' | 'vin' | 'kilometrage'> & {
  annee?: number | null;
};

export type ClientWithMotos = Client & {
  motos: MotoForClient[];
};

export function useSearchClients(query: string) {
  return useQuery({
    queryKey: ['clients', { q: query }],
    queryFn: () =>
      api.get<{ clients: ClientWithMotos[] }>(`/clients${query ? `?q=${encodeURIComponent(query)}` : ''}`),
    select: (d) => d.clients,
    enabled: query.length === 0 || query.length >= 2,
    staleTime: 30_000,
  });
}

export function useCreateClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { nom: string; prenom: string; telephone: string; email?: string }) =>
      api.post<{ client: Client }>('/clients', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });
}

export function useCreateMoto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      clientId: string;
      modele: string;
      vin: string;
      annee?: number;
      kilometrage?: number;
    }) => api.post<{ moto: Motorcycle }>('/motos', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });
}
